import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { AuthService } from '../../shared/service/auth.service';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { generateCode } from 'src/app/consts/conts.global';
import { filter, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from '../confirmation-box/confirmation-box.component';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent implements OnInit, OnDestroy {
  userData = this.authService.userData;
  emailInput: string;
  isShown: boolean;
  isShown2: boolean;
  user: any;
  isAdmin = false;
  adminCode: string;
  isEntreprenerEdit = false;
  isUserCodeAssociatedWithAssessment$: Observable<boolean>;
  private unsubscribe = new Subject();

  //dummy text
  dummyText =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas vel est eu sapien faucibus maximus a in tortor. Vivamus posuere odio a dignissim porta. Nam risus justo, cursus eget sem eu, rutrum molestie magna. Etiam sollicitudin volutpat ante, sed laoreet tellus consequat non. Fusce mi tortor, faucibus id congue ut, tincidunt rutrum lectus. Cras ut tellus non dolor congue molestie eu ac justo. Integer sapien sem, interdum eget felis quis, laoreet facilisis risus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Phasellus ut ligula metus. Mauris efficitur est vitae lorem laoreet, in rutrum nibh suscipit. Nunc fermentum libero metus, in porttitor sapien euismod sed. Phasellus ac urna vulputate, maximus nisi sed, sollicitudin nibh. Aenean sed lacinia augue, ut sollicitudin ipsum';

  constructor(
    private db: AngularFirestore,
    public authService: AuthService,
    public router: Router,
    public ngZone: NgZone,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.db
      .collection('users')
      .doc(this.authService?.userData?.uid)
      .valueChanges()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((payload: any) => {
        if (!payload?.adminCode?.disabled) {
          this.adminCode = payload?.adminCode?.timestampedcreation
            ? payload?.adminCode?.value
            : payload?.adminCode;
        }
        this.authService.adminCode = payload?.adminCode;
      });
    this.isAdmin =
      this.authService?.userData?.displayName?.includes('Admin') ||
      this.authService.userData?.typeOfUser === 'Admin';

    if (this.isAdmin) {
      this.isShown = true;
      this.isShown2 = false;
    } else {
      this.isShown = false;
      this.isShown2 = true;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onSubmit2(value: string) {
    this.isEntreprenerEdit = !value.trim();
    if (!value || this.adminCode === value) {
      return;
    }
    this.adminCode = value.trim();
    !!value &&
      this.db
        .collection('users')
        .doc(this.authService.userData.uid)
        .update({
          adminCode: {
            value: this.adminCode,
            timestampedcreation: Date.now(),
            timezone: Intl.DateTimeFormat()?.resolvedOptions()?.timeZone,
          },
        });
    this.db
      .collection('user-admin-code-removed')
      .doc(this.authService?.userData?.uid)
      .delete();
    this.authService.adminCode = {
      value: this.adminCode,
      timestampedcreation: Date.now(),
      timezone: Intl.DateTimeFormat()?.resolvedOptions()?.timeZone,
    };
  }

  remove(): void {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        title: 'Delete',
        content: `This action can not be undone and you <strong>will be unlinked</strong> to any assessments associated with this code. <br/>Your clients' assessments <strong>will be removed</strong> from your assessments list.`,
        action: 'Delete',
      },
    });
    dialogRef
      .afterClosed()
      .pipe(filter((response) => response === 'Delete'))
      .subscribe(() => {
        this.db
          .collection('users')
          .doc(this.authService.userData.uid)
          .update({
            adminCode: {
              value : typeof this.authService.adminCode === 'string' ? this.authService.adminCode : this.authService.adminCode?.value,
              timestampedremove: Date.now(),
              disabled: true,
              timestampedcreation: this.authService?.adminCode?.timestampedcreation ||  null,
              timezone: this.authService?.adminCode?.timezone || null
            },
          })
          .then(() => {
            this.adminCode = null;
            this.authService.adminCode = {
              value : typeof this.authService.adminCode === 'string' ? this.authService.adminCode : this.authService.adminCode?.value,
              timestampedremove: Date.now(),
              disabled: true,
              timestampedcreation: this.authService?.adminCode?.timestampedcreation ||  null,
              timezone: this.authService?.adminCode?.timezone || null
            };
          });
        this.db
          .collection('user-admin-code-removed')
          .doc(this.authService?.userData?.uid)
          .set({
            adminCode: this.authService.adminCode,
            disabled: true,
            timestamp: Date.now(),
          });
      });
  }

  submitCode(isDisabled = false): void {
    if (isDisabled) {
      return;
    }
    const code = generateCode(30);
    this.adminCode = code;
    this.db
      .collection('users')
      .doc(this.authService.userData.uid)
      .update({
        adminCode: {
          value: this.adminCode,
          timestampedcreation: Date.now(),
          timezone: Intl.DateTimeFormat()?.resolvedOptions()?.timeZone,
        },
      });
    this.db
      .collection('user-admin-code-removed')
      .doc(this.authService?.userData?.uid)
      .delete();
    this.authService.adminCode = {
      value: this.adminCode,
      timestampedcreation: Date.now(),
      timezone: Intl.DateTimeFormat()?.resolvedOptions()?.timeZone,
    };
  }

  checkTypeOfUser() {
    if (this.userData.displayName.includes('Entrepreneur')) {
      console.log('yo');
    } else {
      console.log('yoooo');
    }
  }
}
